/// <reference path="../typings/global.d.ts" />

export class ScreenLoadUtility {
    public static StartLoadingScreen(element?) : void {
        $("#loadingScreen").modal("show");
    }

    public static StopLoadingScreen(element?) : void {
        $("#loadingScreen").modal("hide");
    }

}

